import { Link } from "react-router-dom";

export default function ClientMeetings({ meetings = [] }) {
  return (
    <div className="client-card">
      <h2>Upcoming Meetings</h2>
      {meetings.length === 0 ? <p>No upcoming meetings.</p> : meetings.map((meeting) => (
        <Link key={meeting.id} to={`/meetings/${meeting.id}`} className="meeting-row">
          <strong>{meeting.title}</strong>
          <p>{meeting.start_at ? new Date(meeting.start_at).toLocaleString() : meeting.status_label}</p>
        </Link>
      ))}
    </div>
  );
}